export enum EventType {
  CUSTOM = 'custom',
  OFFLINE_ACTIVITY = 'offline_activity',
  WEBINAR = 'webinar',
  LEARNING_PATH_DEADLINE = 'lp_deadline',
  CHALLENGE_DEADLINE = 'challenge_deadline',
  IN_PERSON = 'in_person'
}
